import { render, staticRenderFns } from "./r-tab.vue?vue&type=template&id=d169816c&shadow"
import script from "./r-tab.vue?vue&type=script&lang=js&shadow"
export * from "./r-tab.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports